import { DataService } from './../../../../../services/data.service';
import { HomepageSettings } from './../../../../../interfaces/settings';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';

import * as _ from 'lodash';

@Component({
  selector: 'app-super-admin-configs',
  templateUrl: './super-admin-configs.component.html',
  styleUrls: ['./super-admin-configs.component.scss']
})
export class SuperAdminConfigsComponent implements OnInit {

  paymentsSettings: HomepageSettings;

  form: FormGroup;

  isEditing = false;

  constructor(
    private toastr: ToastrService,
    private fb: FormBuilder,
    private data: DataService
  ) { }

  ngOnInit() {
    this.getPaymentsSettings();
  }

  initForm(isEditing = false){
    this.isEditing = isEditing;

    this.form = this.fb.group({
      fees_bronze: new FormControl(this.paymentsSettings.fees.bronze, [Validators.required]),
      fees_silver: new FormControl(this.paymentsSettings.fees.silver, [Validators.required]),
      fees_gold: new FormControl(this.paymentsSettings.fees.gold, [Validators.required]),
      pricePerCredit: new FormControl(this.paymentsSettings.pricePerCredit, [Validators.required]),
      creditsToPurchase: new FormControl(this.paymentsSettings.creditsToPurchase.join(', '), [Validators.required]),
      categories: new FormControl(this.paymentsSettings.categories.join(', '), [Validators.required]),
    })
  }

  async getPaymentsSettings(){
    this.data.getSettings('configs').subscribe((res) => {
      if(res && res.data){
        this.paymentsSettings = res.data;

        this.initForm();
      }
    })
  }

  async save(){
    try{
      if(this.form.invalid){
        throw Error('Form is invalid.');
      }

      const {value: data} = this.form;

      const creditsToPurchase = _.map(_.split(data.creditsToPurchase, ','), v => parseInt(_.trim(v)));

      if(creditsToPurchase.length === 0 || !_.every(creditsToPurchase, v => typeof v === 'number')){
        throw Error('Invalid credits field.');
      }

      const categories = _.map(_.split(data.categories, ','), v => _.startCase(_.trim(v)));

      const paymentsSettings = {
        fees: {
          bronze: parseInt(data.fees_bronze),
          silver: parseInt(data.fees_silver),
          gold: parseInt(data.fees_gold)
        },
        pricePerCredit: parseInt(data.pricePerCredit),
        creditsToPurchase: creditsToPurchase,
        categories: categories
      }

      this.data.updateSettings('configs', paymentsSettings).subscribe((res) => {
        if(res){
          this.getPaymentsSettings();
          this.isEditing = false;
        }
      })
    }catch(e){
      console.error(e);
      this.toastr.error(e.message);
    }
  }
}
